export default "__VITE_ASSET__itNLJOmy__"